import instance from "./instance";
import {
  SubscriptionResponseDto,
  SubscriptionProductCreateRequestDto,
  SubscriptionProductDetailResponseDto,
  SubscriptionProductSelectionDto,
} from "@/dto/SubscriptionDto";
import { ENV } from "@/constants/env";
import { ResponseDataDto } from "@/dto/ResponseDto";

// 구독 상품 관리 API 경로
const PREFIX_PATH = "admin/subscription-products";

/**
 * 구독 상품 목록 조회
 * @returns 구독 상품 목록
 */
export const findAll = async (): Promise<SubscriptionResponseDto> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}`);
};

/**
 * 구독 상품 생성
 * @param request 구독 상품 생성 요청 DTO
 * @returns 구독 상품 생성 응답 DTO
 */
export const create = async (
  request: SubscriptionProductCreateRequestDto
): Promise<SubscriptionResponseDto> => {
  return await instance.post(`${ENV.PRE_FIX}/${PREFIX_PATH}`, request);
};

/**
 * 구독 상품 상세 조회
 * @param productId 구독 상품 ID
 * @returns 구독 상품 상세 응답 DTO
 */
export const findById = async (
  productId: string
): Promise<SubscriptionProductDetailResponseDto> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/${productId}`);
};

/**
 * 구독 상품 수정
 * @param productId 구독 상품 ID
 * @param request 구독 상품 수정 요청 DTO
 * @returns 구독 상품 수정 응답 DTO
 */
export const update = async (
  productId: string,
  request: SubscriptionProductCreateRequestDto
): Promise<SubscriptionResponseDto> => {
  return await instance.put(
    `${ENV.PRE_FIX}/${PREFIX_PATH}/${productId}`,
    request
  );
};

/**
 * 구독 상품만 리스트 조회
 * @returns 구독 상품 리스트 응답 DTO
 */
export const findAllByProduct = async (): Promise<
  ResponseDataDto<SubscriptionProductSelectionDto[]>
> => {
  return await instance.get(`${ENV.PRE_FIX}/${PREFIX_PATH}/selection`);
};
